export default __webpack_public_path__ + "img/Lavkush.19394399.jpeg";